import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  TextField,
  Grid,
  InputAdornment,
  Chip,
  Checkbox,
  Slide,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  ClickAwayListener,
  GlobalStyles,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import UpdateIcon from '@mui/icons-material/Update';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';

// استيراد الـ actions
import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
import { Get_All_Sales_By_Managers_Email_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// Transition للـ offcanvas من اليمين
const SlideTransition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

// أيقونات الـ Checkbox
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// Global styles لضبط z-index للتقويم
const globalStyles = (
  <GlobalStyles
    styles={{
      '.MuiPickersPopper-root': {
        zIndex: '999999 !important',
      },
      '.MuiPaper-root.MuiPickersPopper-paper': {
        zIndex: '999999 !important',
        maxHeight: '400px !important',
        overflow: 'auto !important',
      },
    }}
  />
);

export const ManagerQuickFilterModal = ({ open, onClose, onApplyFilters, userlogin }) => {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch = useDispatch();

  // دوال مساعدة لتصنيف الـ roles
  const getRoleBadge = (user) => {
    if (!user?.userlog?.role) return null;

    const role = user.userlog.role;
    const roleColors = {
      'Team Leader': { bg: mode === 'dark' ? '#7b1fa2' : '#9c27b0', text: '#fff' },
      Manager: { bg: mode === 'dark' ? '#2c3e50' : '#34495e', text: '#fff' },
      Sales: { bg: mode === 'dark' ? '#1976d2' : '#1976d2', text: '#fff' },
      User: { bg: mode === 'dark' ? '#388e3c' : '#4caf50', text: '#fff' },
    };

    return roleColors[role] || { bg: mode === 'dark' ? '#757575' : '#9e9e9e', text: '#fff' };
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'Team Leader':
        return '👑';
      case 'Manager':
        return '💼';
      case 'Sales':
        return '🛒';
      default:
        return '👤';
    }
  };

  // States للفلاتر - بدون oldstage
  const [filters, setFilters] = useState({
    budget: '',
    stage: [],
    sales: [],
    chanel: [],
    campaign: [],
    project: [],
    developer: [],
    addby: [],
    assignedFrom: [],
    assignedTo: [],
    date: {
      // 👈 استخدمنا date بدل createdAt
      from: null,
      to: null,
    },
    stagedateupdated: {
      from: null,
      to: null,
    },
  });

  // State للقائمة المفتوحة حاليًا
  const [openMenu, setOpenMenu] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

  // Refs للحقول
  const fieldRefs = {
    stage: useRef(null),
    sales: useRef(null),
    chanel: useRef(null),
    campaign: useRef(null),
    project: useRef(null),
    developer: useRef(null),
    addby: useRef(null),
    assignedFrom: useRef(null),
    assignedTo: useRef(null),
  };

  // جلب البيانات من Redux
  const ressales = useSelector((state) => state.AllSales.sales);
  const reschannel = useSelector((state) => state.AllChannalRoot.channal);
  const resproject = useSelector((state) => state.AllProjects.Projects);
  const resstages = useSelector((state) => state.Allstages.stage);
  const resdevelopers = useSelector((state) => state.AllDevelopers.Developers);
  const rescampaigns = useSelector((state) => state.AllCampaign.campaign);
  const resusersAuth = useSelector((state) => state.AuthRoot.Signup);

  // ✅ تصفية الـ Sales - نجيب بس اللي الـ Manager بتاعهم = userlogin.data._id
  const salesarray = useMemo(() => {
    console.log('🔍 ressales for manager:', ressales);
    console.log('🔍 managerId:', userlogin?.data?._id);

    if (!ressales?.data || !Array.isArray(ressales.data)) return [];

    // فلترة الـ sales اللي تحت الـ Manager
    const filteredSales = ressales.data.filter((sale) => {
      const hasManager =
        sale?.Manager && sale.Manager._id?.toString() === userlogin?.data?._id?.toString();
      const notDefault = ![
        'Default',
        'Default M',
        'Default T',
        'Default S',
        'Developer',
        'Dev',
      ].includes(sale?.name);
      console.log(
        `🔍 Sale ${sale?.name}: hasManager=${hasManager}, Manager ID: ${sale?.Manager?._id}, Role: ${sale?.userlog?.role}`,
      );
      return hasManager && notDefault;
    });

    // فصل الـ Team Leaders عن باقي الـ Sales
    const teamLeaders = filteredSales.filter((sale) => sale?.userlog?.role === 'Team Leader');
    const otherSales = filteredSales.filter((sale) => sale?.userlog?.role !== 'Team Leader');

    // ترتيب كل مجموعة أبجدياً
    teamLeaders.sort((a, b) => a?.name?.localeCompare(b?.name));
    otherSales.sort((a, b) => a?.name?.localeCompare(b?.name));

    // دمج المجموعتين (Team Leaders الأول)
    return [...teamLeaders, ...otherSales];
  }, [ressales, userlogin]);

  // باقي البيانات
  const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
  const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
  const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
  const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
  const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

  const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : []).filter(
    (user) =>
      !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(user?.name),
  );

  const getallfiltersarray = async () => {
    // نجيب الـ Sales الخاصة بالـ Manager بس
    if (userlogin?.data?.email) {
      await dispatch(Get_All_Sales_By_Managers_Email_Action(userlogin.data.email));
    }
    await dispatch(GetAllchannalData());
    await dispatch(GetallProjectsdata());
    await dispatch(GetAll_stage_Data());
    await dispatch(GetDevelopersData());
    await dispatch(GetAllCampainData());
  };

  useEffect(() => {
    if (open && userlogin?.data?.email) {
      getallfiltersarray();
    }
  }, [open, userlogin]);

  // دوال التعامل مع الفلاتر
  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  const handleBudgetChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      budget: value,
    }));
  };

  const handleDateChange = (dateType, value) => {
    setFilters((prev) => ({
      ...prev,
      date: {
        ...prev.date,
        [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
      },
    }));
  };

  const handleStageDateChange = (dateType, value) => {
    setFilters((prev) => ({
      ...prev,
      stagedateupdated: {
        ...prev.stagedateupdated,
        [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
      },
    }));
  };

  const handleItemToggle = (filterType, item) => {
    setFilters((prev) => {
      const current = prev[filterType];
      const isSelected = current.some((i) => getItemId(i) === getItemId(item));

      if (isSelected) {
        return {
          ...prev,
          [filterType]: current.filter((i) => getItemId(i) !== getItemId(item)),
        };
      } else {
        return {
          ...prev,
          [filterType]: [...current, item],
        };
      }
    });
  };

  const handleSelectAll = (filterType, options) => {
    setFilters((prev) => {
      const current = prev[filterType];
      if (current.length === options.length) {
        return {
          ...prev,
          [filterType]: [],
        };
      } else {
        return {
          ...prev,
          [filterType]: [...options],
        };
      }
    });
  };

  const handleOpenMenu = (menuType) => {
    const fieldRef = fieldRefs[menuType];
    if (fieldRef.current) {
      const rect = fieldRef.current.getBoundingClientRect();
      setAnchorPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
      });
      setOpenMenu(menuType);
      setSearchValue('');
    }
  };

  const handleCloseMenu = () => {
    setOpenMenu(null);
    setSearchValue('');
  };

  const getDisplayName = (item) => {
    if (typeof item === 'string') return item;
    return item?.name || item?.CampainName || item?.title || 'Unknown';
  };

  const getItemId = (item) => {
    return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
  };

  const handleApplyFilters = () => {
    const cleanedFilters = {
      ...filters,
      stage: filters.stage.filter((item) => item),
      sales: filters.sales.filter((item) => item),
      chanel: filters.chanel.filter((item) => item),
      campaign: filters.campaign.filter((item) => item),
      project: filters.project.filter((item) => item),
      developer: filters.developer.filter((item) => item),
      addby: filters.addby.filter((item) => item),
      assignedFrom: filters.assignedFrom.filter((item) => item),
      assignedTo: filters.assignedTo.filter((item) => item),
      budget: filters.budget || '',
      date: {
        from: filters.date.from,
        to: filters.date.to,
      },
      stagedateupdated: {
        from: filters.stagedateupdated.from,
        to: filters.stagedateupdated.to,
      },
    };

    console.log('🔍 Applying filters:', cleanedFilters);

    const queryParams = new URLSearchParams();

    const multiValueFields = [
      'stage',
      'sales',
      'chanel',
      'campaign',
      'project',
      'developer',
      'addby',
    ];

    multiValueFields.forEach((field) => {
      if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
        cleanedFilters[field].forEach((item) => {
          const itemId = getItemId(item);
          if (itemId) {
            queryParams.append(field, itemId);
          }
        });
      }
    });

    if (cleanedFilters.assignedFrom && cleanedFilters.assignedFrom.length > 0) {
      cleanedFilters.assignedFrom.forEach((item) => {
        const itemId = getItemId(item);
        if (itemId) {
          queryParams.append('assignedFrom', itemId);
        }
      });
    }

    if (cleanedFilters.assignedTo && cleanedFilters.assignedTo.length > 0) {
      cleanedFilters.assignedTo.forEach((item) => {
        const itemId = getItemId(item);
        if (itemId) {
          queryParams.append('assignedTo', itemId);
        }
      });
    }

    if (cleanedFilters.budget) {
      queryParams.append('budget', cleanedFilters.budget);
    }

    if (cleanedFilters.date.from) {
      queryParams.append('createdFrom', cleanedFilters.date.from);
    }
    if (cleanedFilters.date.to) {
      queryParams.append('createdTo', cleanedFilters.date.to);
    }

    if (cleanedFilters.stagedateupdated.from) {
      queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
    }
    if (cleanedFilters.stagedateupdated.to) {
      queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
    }

    const queryString = queryParams.toString();
    console.log('🔍 Final Query String:', queryString);

    onApplyFilters(cleanedFilters, queryString);
    onClose();
  };

  const handleClearFilters = () => {
    setFilters({
      budget: '',
      stage: [],
      sales: [],
      chanel: [],
      campaign: [],
      project: [],
      developer: [],
      addby: [],
      assignedFrom: [],
      assignedTo: [],
      date: {
        from: null,
        to: null,
      },
      stagedateupdated: {
        from: null,
        to: null,
      },
    });
    handleCloseMenu();
  };

  const MenuComponent = () => {
    if (!openMenu) return null;

    let options = [];
    switch (openMenu) {
      case 'stage':
        options = stagesarray;
        break;
      case 'sales':
        options = salesarray;
        break;
      case 'chanel':
        options = channelarray;
        break;
      case 'campaign':
        options = campaignsarray;
        break;
      case 'project':
        options = projectarray;
        break;
      case 'developer':
        options = developersarray;
        break;
      case 'addby':
        options = usersarray;
        break;
      case 'assignedFrom':
        options = usersarray;
        break;
      case 'assignedTo':
        options = salesarray;
        break;
      default:
        options = [];
    }

    const selectedItems = filters[openMenu] || [];

    const filteredOptions = options.filter(
      (option) =>
        getDisplayName(option).toLowerCase().includes(searchValue.toLowerCase()) ||
        selectedItems.some((selected) => getItemId(selected) === getItemId(option)),
    );

    const handleItemClick = (item) => {
      handleItemToggle(openMenu, item);
    };

    return (
      <ClickAwayListener onClickAway={handleCloseMenu}>
        <Paper
          sx={{
            position: 'fixed',
            top: anchorPosition.top,
            left: anchorPosition.left,
            width: anchorPosition.width || 300,
            maxHeight: 400,
            backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
            border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
            borderRadius: '8px',
            overflow: 'hidden',
            zIndex: 999998,
          }}
        >
          <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
            <TextField
              fullWidth
              size="small"
              placeholder={`Search...`}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              autoFocus
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: searchValue && (
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setSearchValue('')} edge="end">
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  fontSize: '14px',
                },
              }}
            />
          </Box>

          <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
            <Button
              onClick={() => handleSelectAll(openMenu, options)}
              size="small"
              fullWidth
              sx={{
                textTransform: 'none',
                fontSize: '0.75rem',
                color: mode === 'dark' ? '#90caf9' : '#1976d2',
                justifyContent: 'flex-start',
                paddingLeft: 2,
              }}
            >
              {selectedItems.length === options.length ? 'Deselect All' : 'Select All'}
            </Button>
          </Box>

          <List
            sx={{
              maxHeight: 300,
              overflow: 'auto',
              p: 0,
            }}
          >
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => {
                const isSelected = selectedItems.some(
                  (item) => getItemId(item) === getItemId(option),
                );

                return (
                  <ListItem
                    key={getItemId(option) || index}
                    onClick={() => handleItemClick(option)}
                    sx={{
                      py: 1,
                      px: 2,
                      cursor: 'pointer',
                      backgroundColor: isSelected
                        ? mode === 'dark'
                          ? 'rgba(25, 118, 210, 0.2)'
                          : 'rgba(25, 118, 210, 0.1)'
                        : 'transparent',
                      color: mode === 'dark' ? '#fff' : '#000',
                      '&:hover': {
                        backgroundColor: isSelected
                          ? mode === 'dark'
                            ? 'rgba(25, 118, 210, 0.3)'
                            : 'rgba(25, 118, 210, 0.15)'
                          : mode === 'dark'
                            ? 'rgba(255,255,255,0.1)'
                            : 'rgba(0,0,0,0.04)',
                      },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      <Checkbox
                        checked={isSelected}
                        icon={icon}
                        checkedIcon={checkedIcon}
                        sx={{
                          color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
                          '&.Mui-checked': {
                            color: mode === 'dark' ? '#90caf9' : '#1976d2',
                          },
                        }}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Box
                          sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}
                        >
                          <span>{getDisplayName(option)}</span>
                          {option?.userlog?.role && (
                            <Chip
                              label={`${getRoleIcon(option.userlog.role)} ${option.userlog.role}`}
                              size="small"
                              sx={{
                                height: 20,
                                fontSize: '0.65rem',
                                backgroundColor: getRoleBadge(option).bg,
                                color: getRoleBadge(option).text,
                                fontWeight: '500',
                                '& .MuiChip-label': {
                                  px: 1,
                                },
                              }}
                            />
                          )}
                        </Box>
                      }
                      secondary={
                        option?.userlog?.email ? (
                          <Typography variant="caption" color={mode === 'dark' ? '#aaa' : '#666'}>
                            {option.userlog.email}
                          </Typography>
                        ) : null
                      }
                      primaryTypographyProps={{
                        fontSize: '14px',
                        fontWeight: isSelected ? '500' : '400',
                      }}
                    />
                  </ListItem>
                );
              })
            ) : (
              <ListItem disabled sx={{ justifyContent: 'center', py: 2 }}>
                <Typography variant="body2" color="text.secondary">
                  No options found
                </Typography>
              </ListItem>
            )}
          </List>
        </Paper>
      </ClickAwayListener>
    );
  };

  const FilterField = ({
    title,
    filterType,
    icon: customIcon,
    placeholder = `Select ${title}...`,
  }) => {
    const selectedItems = filters[filterType] || [];
    const isOpen = openMenu === filterType;

    const handleClick = () => {
      if (isOpen) {
        handleCloseMenu();
      } else {
        handleOpenMenu(filterType);
      }
    };

    const handleRemoveItem = (item, event) => {
      event.stopPropagation();
      handleItemToggle(filterType, item);
    };

    return (
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {customIcon && customIcon}
            <Typography sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#000' }}>
              {title}
            </Typography>
          </Box>
        </Box>

        <Box
          ref={fieldRefs[filterType]}
          onClick={handleClick}
          sx={{
            border: '1px solid',
            borderColor: isOpen
              ? mode === 'dark'
                ? '#90caf9'
                : '#1976d2'
              : mode === 'dark'
                ? '#444'
                : '#ccc',
            borderRadius: '4px',
            backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
            minHeight: '40px',
            padding: '8px 12px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '&:hover': {
              borderColor: mode === 'dark' ? '#666' : '#999',
            },
            position: 'relative',
            outline: isOpen ? `2px solid ${mode === 'dark' ? '#90caf9' : '#1976d2'}` : 'none',
            outlineOffset: '-2px',
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
            {selectedItems.length > 0 ? (
              selectedItems.slice(0, 3).map((item, index) => (
                <Chip
                  key={index}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                      <span>{getDisplayName(item)}</span>
                      {item?.userlog?.role && filterType === 'sales' && (
                        <span
                          style={{
                            fontSize: '0.6rem',
                            opacity: 0.9,
                            backgroundColor: 'rgba(255,255,255,0.2)',
                            padding: '2px 4px',
                            borderRadius: '4px',
                            marginLeft: '4px',
                          }}
                        >
                          {item.userlog.role}
                        </span>
                      )}
                    </Box>
                  }
                  size="small"
                  onDelete={(e) => handleRemoveItem(item, e)}
                  sx={{
                    height: 24,
                    fontSize: '0.7rem',
                    backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
                    color: mode === 'dark' ? '#fff' : '#1976d2',
                    '& .MuiChip-deleteIcon': {
                      fontSize: '1rem',
                      color: 'inherit',
                      '&:hover': {
                        color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
                      },
                    },
                  }}
                />
              ))
            ) : (
              <Typography
                variant="body2"
                sx={{
                  color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
                  fontStyle: 'italic',
                }}
              >
                {placeholder}
              </Typography>
            )}
            {selectedItems.length > 3 && (
              <Chip
                label={`+${selectedItems.length - 3} more`}
                size="small"
                sx={{
                  height: 24,
                  fontSize: '0.7rem',
                  backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                  color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
                }}
              />
            )}
          </Box>
          <ArrowDropDownIcon
            sx={{
              color: isOpen
                ? mode === 'dark'
                  ? '#90caf9'
                  : '#1976d2'
                : mode === 'dark'
                  ? '#aaa'
                  : '#666',
              ml: 1,
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          />
        </Box>

        {selectedItems.length > 0 && (
          <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selectedItems.map((item, index) => (
              <Chip
                key={index}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <span>{getDisplayName(item)}</span>
                    {item?.userlog?.role && filterType === 'sales' && (
                      <span
                        style={{
                          fontSize: '0.6rem',
                          opacity: 0.9,
                          backgroundColor: 'rgba(255,255,255,0.2)',
                          padding: '2px 4px',
                          borderRadius: '4px',
                          marginLeft: '4px',
                        }}
                      >
                        {item.userlog.role}
                      </span>
                    )}
                  </Box>
                }
                size="small"
                onDelete={(e) => handleRemoveItem(item, e)}
                sx={{
                  height: 24,
                  fontSize: '0.7rem',
                  backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
                  color: mode === 'dark' ? '#fff' : '#1976d2',
                  '& .MuiChip-deleteIcon': {
                    fontSize: '1rem',
                    color: 'inherit',
                    '&:hover': {
                      color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
                    },
                  },
                }}
              />
            ))}
          </Box>
        )}
      </Box>
    );
  };

  return (
    <>
      {globalStyles}
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        fullScreen={isSmallScreen}
        style={{ zIndex: '50000' }}
        TransitionComponent={SlideTransition}
        PaperProps={{
          sx: {
            borderRadius: 0,
            backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
            backgroundImage: 'none',
            margin: 0,
            height: '100vh',
            width: isSmallScreen ? '100vw' : '600px',
            maxWidth: '600px !important',
            position: 'fixed',
            right: 0,
            top: 0,
            bottom: 0,
            overflow: 'hidden',
            boxShadow: '0 0 20px rgba(0,0,0,0.3)',
          },
        }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          '& .MuiDialog-container': {
            overflow: 'hidden',
          },
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
            color: 'white',
            padding: '16px 24px',
            position: 'sticky',
            top: 0,
            zIndex: 9999,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            minHeight: '64px',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FilterListIcon />
            <Typography variant="h6" component="span">
              Quick Filter
            </Typography>
          </Box>
          <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            p: 3,
            overflow: 'auto',
            width: '100%',
            margin: 0,
            height: 'calc(100vh - 128px)',
          }}
        >
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid container spacing={3} alignItems="flex-start">
              <Grid item xs={12}>
                {/* Budget Filter */}
                <Box
                  sx={{
                    mb: 3,
                    minHeight: '95px',
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '40px',
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{
                      fontWeight: '600',
                      fontSize: '0.95rem',
                      minHeight: '24px',
                      lineHeight: '1.2',
                      color: mode === 'dark' ? '#fff' : '#000',
                    }}
                  >
                    Budget
                  </Typography>
                  <Box sx={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Enter budget amount..."
                      value={filters.budget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      type="number"
                      sx={{
                        width: '100%',
                        '& .MuiInputBase-root': {
                          width: '100%',
                          backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
                        },
                        '& .MuiOutlinedInput-root': {
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: mode === 'dark' ? '#666' : '#1976d2',
                          },
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography
                              variant="body2"
                              color={mode === 'dark' ? '#aaa' : 'text.secondary'}
                            >
                              $
                            </Typography>
                          </InputAdornment>
                        ),
                        endAdornment: filters.budget && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => handleBudgetChange('')}>
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color={mode === 'dark' ? '#aaa' : 'text.secondary'}
                    sx={{ mt: 0.5, display: 'block', minHeight: '20px' }}
                  >
                    Enter the budget amount
                  </Typography>
                </Box>

                {/* Stage Filter */}
                <FilterField title="Stage" filterType="stage" placeholder="Select Stage..." />

                {/* Sales Filter */}
                <FilterField title="Sales" filterType="sales" placeholder="Select Sales..." />

                {/* Channel Filter */}
                <FilterField title="Channel" filterType="chanel" placeholder="Select Channel..." />

                {/* Campaign Filter */}
                <FilterField
                  title="Campaign"
                  filterType="campaign"
                  placeholder="Select Campaign..."
                />

                {/* Project Filter */}
                <FilterField title="Project" filterType="project" placeholder="Select Project..." />

                {/* Developer Filter */}
                <FilterField
                  title="Developer"
                  filterType="developer"
                  placeholder="Select Developer..."
                />

                {/* Added By Filter */}
                <FilterField title="Added By" filterType="addby" placeholder="Select Added By..." />

                {/* Assigned From Filter */}
                <FilterField
                  title="Assigned From"
                  filterType="assignedFrom"
                  icon={
                    <AssignmentIndIcon
                      fontSize="small"
                      sx={{ mr: 0.5, color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }}
                    />
                  }
                  placeholder="Select Assigned From..."
                />

                {/* Assigned To Filter */}
                <FilterField
                  title="Assigned To"
                  filterType="assignedTo"
                  icon={
                    <AssignmentTurnedInIcon
                      fontSize="small"
                      sx={{ mr: 0.5, color: mode === 'dark' ? '#81c784' : '#1976d2' }}
                    />
                  }
                  placeholder="Select Assigned To..."
                />

                {/* Creation Date Range - باستخدام date */}
                <Box
                  sx={{
                    mb: 3,
                    p: 2,
                    border: '1px solid',
                    borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                    borderRadius: 1,
                    minHeight: '110px',
                    backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fafafa',
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    sx={{
                      fontWeight: '600',
                      fontSize: '0.95rem',
                      minHeight: '24px',
                      lineHeight: '1.2',
                      color: mode === 'dark' ? '#fff' : '#000',
                    }}
                  >
                    Creation Date Range
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <DatePicker
                        label="From Date"
                        value={filters.date.from ? moment(filters.date.from) : null}
                        onChange={(date) => handleDateChange('from', date)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <DatePicker
                        label="To Date"
                        value={filters.date.to ? moment(filters.date.to) : null}
                        onChange={(date) => handleDateChange('to', date)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                      />
                    </Grid>
                  </Grid>
                </Box>

                {/* Stage Date Range */}
                <Box
                  sx={{
                    mb: 3,
                    p: 2,
                    border: '1px solid',
                    borderColor: mode === 'dark' ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)',
                    borderRadius: 1,
                    minHeight: '110px',
                    backgroundColor:
                      mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <UpdateIcon fontSize="small" color="warning" />
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      sx={{
                        fontWeight: '600',
                        fontSize: '0.95rem',
                        minHeight: '24px',
                        lineHeight: '1.2',
                        color: mode === 'dark' ? '#ff9800' : '#1976d2',
                      }}
                    >
                      Stage Date Range
                    </Typography>
                  </Box>
                  <Typography
                    variant="caption"
                    color={mode === 'dark' ? '#aaa' : 'text.secondary'}
                    gutterBottom
                    sx={{ display: 'block', mb: 2 }}
                  >
                    Filter by stage update date (Stage Date Updated)
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                      <DatePicker
                        label="Stage Date From"
                        value={
                          filters.stagedateupdated.from
                            ? moment(filters.stagedateupdated.from)
                            : null
                        }
                        onChange={(date) => handleStageDateChange('from', date)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <DatePicker
                        label="Stage Date To"
                        value={
                          filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null
                        }
                        onChange={(date) => handleStageDateChange('to', date)}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            {/* Selected Filters Summary */}
            {(filters.budget ||
              Object.values(filters).some((val) =>
                Array.isArray(val)
                  ? val.length > 0
                  : typeof val === 'object' && val !== null
                    ? val.from || val.to
                    : false,
              )) && (
              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  backgroundColor:
                    mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)',
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#000' }}
                >
                  Selected Filters:
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {filters.budget && (
                    <Chip
                      label={`Budget: $${filters.budget}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      onDelete={() => handleBudgetChange('')}
                      deleteIcon={<ClearIcon />}
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.stage.length > 0 && (
                    <Chip
                      label={`Stage: ${filters.stage.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.sales.length > 0 && (
                    <Chip
                      label={`Sales: ${filters.sales.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.chanel.length > 0 && (
                    <Chip
                      label={`Channel: ${filters.chanel.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.campaign.length > 0 && (
                    <Chip
                      label={`Campaign: ${filters.campaign.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.project.length > 0 && (
                    <Chip
                      label={`Project: ${filters.project.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.developer.length > 0 && (
                    <Chip
                      label={`Developer: ${filters.developer.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.addby.length > 0 && (
                    <Chip
                      label={`Added By: ${filters.addby.length}`}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {filters.assignedFrom.length > 0 && (
                    <Chip
                      label={`Assigned From: ${filters.assignedFrom.length}`}
                      size="small"
                      color="info"
                      variant="outlined"
                      icon={<AssignmentIndIcon />}
                      sx={{ color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }}
                    />
                  )}
                  {filters.assignedTo.length > 0 && (
                    <Chip
                      label={`Assigned To: ${filters.assignedTo.length}`}
                      size="small"
                      color="success"
                      variant="outlined"
                      icon={<AssignmentTurnedInIcon />}
                      sx={{ color: mode === 'dark' ? '#81c784' : '#1976d2' }}
                    />
                  )}
                  {(filters.date.from || filters.date.to) && (
                    <Chip
                      label="Creation Date Range"
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
                    />
                  )}
                  {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
                    <Chip
                      label="Stage Date Range"
                      size="small"
                      color="warning"
                      variant="outlined"
                      icon={<UpdateIcon />}
                      sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
                    />
                  )}
                </Box>
              </Box>
            )}
          </LocalizationProvider>

          {openMenu && <MenuComponent />}
        </DialogContent>

        <DialogActions
          sx={{
            p: 3,
            gap: 1,
            borderTop: '1px solid',
            borderColor: 'divider',
            position: 'sticky',
            bottom: 0,
            backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
          }}
        >
          <Button
            onClick={handleClearFilters}
            variant="outlined"
            sx={{
              color: mode === 'dark' ? '#ffffff' : '#1976d2',
              borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
              '&:hover': { borderColor: mode === 'dark' ? '#ffffff' : '#1976d2' },
            }}
          >
            Clear All
          </Button>
          <Box sx={{ flex: 1 }} />
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              color: mode === 'dark' ? '#ffffff' : '#666',
              borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleApplyFilters}
            sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
          >
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ManagerQuickFilterModal;
